import { toast } from "react-toastify";
import { ToastOptions } from 'react-toastify/dist/types'
import * as React from "react";

export class StyledToast {
    private static content(content: string): React.ReactFragment {
        return <span className="me-1">{content}</span>
    }

    static warn(content: string, options?: ToastOptions) {
        toast.warn(
            this.content(content),
            {
                ...options,
                className: 'alert-warning'
            }
        )
    }

    static info(content: string, options?: ToastOptions) {
        toast.warn(
            this.content(content),
            {
                ...options,
                className: 'alert-primary'
            }
        )
    }

    static success(content: string, options?: ToastOptions) {
        toast.success(
            this.content(content),
            {
                ...options,
                className: 'alert-success'
            }
        )
    }

    static error(content: string, options?: ToastOptions) : void {
        toast.error(
            this.content(content),
            {
                ...options,
                className: 'alert-danger'
            }
        );
    }
}